<section id="TheFarm">
      <div fxLayout="row" fxLayoutAlign="center start">
         <div fxFlex="100%" fxFlex.gt-md="92%">
           <div fxLayout="row" fxLayoutGap="30px" class="S1py">
              <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center center" >
                <div>
                    <h5>The Farm</h5>
                    <ul>
                       <li>Milking Cows in Douglas</li>
                       <li>County, Missouri since 1997</li>
                    </ul>
                </div>
              </div>
              <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center start">
                 <p>Grison Dairy Farm was founded in 1997 when Swiss Immigrants and second generation dairy farmers Heinz and Vroni Buff bought an existing dairy farm in Douglas County Missouri close to Ava. Named after their native Canton in Switzerland Grison. Over the years emphasis was placed on improving pasture stands and increasing yields. The Buffs see themselves as Stewards of the Land. Care was always and is currently given to the environment. The farm produces most of their own forage. Commercial fertilizer hasn't been used in over 20 years. Sustainability is very important. The Buff family believes the most economical and environmentally friendly way to produce milk is to allow the cows to graze on pristine pastures.</p>
              </div>
           </div>
           <div fxLayout="row" fxLayoutGap="30px">
              <div fxLayout="row" fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center center">
                 <div fxFlex="100%" fxFlex.gt-md="50%">
                    <h5>Going Solar</h5>
                    <p>In 2014 the decision was made to go solar! One hundered pannels were placed on the roof of the newest hay barn, and 20 pannels onto the old barn. Currently the solar pannels produce all the electricity needed for the farm.</p>
                 </div>
              </div>
              <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center start">
                 <img src="https://static.wixstatic.com/media/cf6097_182caca158fc496da4c5753502d1f84e~mv2.jpg/v1/fill/w_952,h_400,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/cf6097_182caca158fc496da4c5753502d1f84e~mv2.jpg" alt="">
              </div>
           </div>
         </div>
      </div>
   </section>
   <section>
     <div fxLayout="row">
        <div fxFlex="100%" fxLayoutAlign="center start">
           <img src="https://static.wixstatic.com/media/cf6097_fe73c5e3538d4648984339c2e3c36955~mv2.jpg/v1/fill/w_1903,h_876,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/cf6097_fe73c5e3538d4648984339c2e3c36955~mv2.jpg" alt="">
        </div>
     </div>
   </section>
   <section class="TheFarm2">
     <div fxLayout="row" fxLayoutAlign="center start" >
           <div fxFlex="100%" fxFlex.gt-md="92%">
              <div fxLayout="row" fxLayoutGap="30px" class="S1py">
                 <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center start">
                    <div>
                       <h5>The Cows</h5>
                    <p>The Grison Herd</p>
                    <button class="btnDefault hand-hover" routerLink="/the-cheesemaker">Learn More</button>
                    </div>
                 </div>
                 <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center start">
                    <div fxFlex="50%">
                       <p>Grison Dairy is home to both Registered Holstein and Brown Swiss cows. Most of the herd consists of homebred cows. During evenings you can normally see the next generation grazing around the house. Emphasis is placed on breeding cows that combine milk production, milk quality, longevity, feed efficiency, with type and style. The farm is currently milking around one hundred cows twice a day and to the joy of the neighbors the cows can be heard by the bells that they wear as they are grazing in the feilds.</p>
                    </div>
                 </div>
               </div>
  
              <div fxLayout="row" fxLayoutGap="30px" class="py-60">
                 <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center start">
                    <img src="https://static.wixstatic.com/media/cf6097_ad6f52c0b57345c5951447ef5e4eeae3~mv2.jpg/v1/fill/w_768,h_508,al_c,q_85,enc_auto/cf6097_ad6f52c0b57345c5951447ef5e4eeae3~mv2.jpg" alt="">
                 </div>
                 <div fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)" fxLayoutAlign="center start">
                    <img src="https://static.wixstatic.com/media/cf6097_47372881c13d40148c889d7e1fb484ab~mv2.jpg/v1/fill/w_727,h_481,al_c,q_80,enc_auto/cf6097_47372881c13d40148c889d7e1fb484ab~mv2.jpg" alt="">
                 </div>
              </div>
  
           </div>
      </div>
  </section>
  <section class="FarmgallerySec">
     <div fxLayout="row" fxLayoutGap="60px">
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_db8725000dbc4a48b5844c36f781304d~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_db8725000dbc4a48b5844c36f781304d~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_4de79c0057d0467c81ded83dfb65e73b~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_4de79c0057d0467c81ded83dfb65e73b~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_f44c839a5b8044d9b40ba593e8886d02~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_f44c839a5b8044d9b40ba593e8886d02~mv2.webp" alt="">
           </div>
        </div>
     </div>
     <div fxLayout="row" fxLayoutGap="60px">
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_6dc1c3ca46a04365836e3d3df7ddf272~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_6dc1c3ca46a04365836e3d3df7ddf272~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_28ccc02fc57f46a6be87af967d73fa8a~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_28ccc02fc57f46a6be87af967d73fa8a~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_8d19e55c4f624bc680b496dedc43b6c5~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_8d19e55c4f624bc680b496dedc43b6c5~mv2.webp" alt="">
           </div>
        </div>
     </div>
     <div fxLayout="row" fxLayoutGap="60px">
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_1b1118300f594573b6bb4f92a7b68c38~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_1b1118300f594573b6bb4f92a7b68c38~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_4142ba201c3d4925958b6a87d82e2fe2~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_4142ba201c3d4925958b6a87d82e2fe2~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_f3789a067dc041be91f8b115941ef646~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_f3789a067dc041be91f8b115941ef646~mv2.webp" alt="">
           </div>
        </div>
     </div>
     <div fxLayout="row" fxLayoutGap="60px">
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_bc874cb4c886497aa552e0c77f372b20~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_bc874cb4c886497aa552e0c77f372b20~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_e697a519fca24dce952bbd0fb5c26e7d~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_e697a519fca24dce952bbd0fb5c26e7d~mv2.webp" alt="">
           </div>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="calc(33.33333% - 60px)" fxLayoutAlign="center start">
           <div>
              <img src="https://static.wixstatic.com/media/cf6097_a9d98a3c37cf44a0810a7779bc25f7d4~mv2.jpg/v1/fill/w_581,h_436,q_90/cf6097_a9d98a3c37cf44a0810a7779bc25f7d4~mv2.webp" alt="">
           </div>
        </div>
     </div>
     <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="space-evenly center">
        <div>
           <button class="btnDefault">More Pictures</button>
        </div>
        <div>
           <button class="btnDefault">For More Pictures Like us on Facebook!</button>
        </div>
     </div>
  </section>